module.exports = __webpack_public_path__ + "media/images/landing/persons/zuzana-zahorova-1a9c5484311473441cb67b112baf774b.png";